import { render, staticRenderFns } from "./TagSlashIcon.vue?vue&type=template&id=dcd47e40&scoped=true"
import script from "./TagSlashIcon.vue?vue&type=script&lang=ts"
export * from "./TagSlashIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd47e40",
  null
  
)

export default component.exports